import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useEffect } from 'react';
import Home from "./Home/Home";
import Contact from "./Contact/Contact";
import Technology from "./Technology/Technology";
import About from "./About/About";
import ProductsPage from "./Products/ProductsPage";
import RnDPage from "./R&D/R&DPage";
import SolutionsPage from "./Solution/SolutionPage";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('./services/analytics').then(({ initAnalytics, trackPageView }) => {
        initAnalytics();
        trackPageView(location.pathname, document.title);
      });
    }
  }, [location]);

  return null;
}

export default function App() {
  return (
    <Router>
      <AnalyticsTracker />
      
      <div className="w-full bg-black">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/rnd" element={<RnDPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/products"
            element={
              <Navigate to="/products/lithium-ion-battery" replace />
            }
          />
          <Route path="/products/:productId" element={<ProductsPage />} />
        </Routes>
      </div>
    </Router>
  );
}